import React from "react";
import { connect } from "react-redux";
import { PlaceOrderTableJson } from "../../DynamicFormsJson/MastersJSON/PlaceOrderTable";
import {
  getPlaceOrderSearchListHeaderDetails,
  getTodaysPlaceOrder,
} from "../../Slice/OrderHeaderList.slice";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import endpoint from "../../config/endpoints";
import {
  creditLimitMsg,
  noInternetMsg,
  sendOrder,
  sendPlacedOrderMsg,
  serverMsg,
  statusmsg,
} from "../../config/messageconstant";
import { PlaceOrderColumns } from "../../tableColumns/table-columns";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadF } from "../PDF/PDFDownload";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import moment from "moment";

class PlaceOrderTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromdate: "",
      todate: "",
      comment: "",
      popUpFlag: false,
      DataToSet: [],
      creditLimit: 0,
      showOrderConfiguration: "",
      showSapCredtLimit: "",
      lang: "2",
    };
  }
  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      const showOrderConfigurationByTime = localStorage.getItem(
        "showOrderConfigurationByTime"
      );

      if (showOrderConfigurationByTime !== null) {
        this.setState({ showOrderConfiguration: showOrderConfigurationByTime });
      } else {
        showLoador({ loador: true });
        apiGet({
          url: endpoint.setting + "/by-key?key=show_order_config_time",
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            console.log(data.data);
            if (data && data.data && Object.keys(data.data).length != 0) {
              if (data.data.settingValue) {
                this.setState({
                  showOrderConfiguration: data.data.settingValue,
                });
              }
            }
          }
        });
      }

      const showSapCredtLimit = localStorage.getItem("showSapCredtLimit");

      this.setState({
        showSapCredtLimit: showSapCredtLimit,
      });

      if (showSapCredtLimit == 1) {
        showLoador({ loador: true });
        apiGet({
          url: endpoint.sapCreditLimit,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({
              msg: creditLimitMsg,
              severity: "error",
            });
          } else {
            if (Object.keys(data.data).length !== 0) {
              if (data.error) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                this.setState({
                  DataToSet: [
                    {
                      xs: 12,
                      sm: 4,
                      md: 4,
                      lg: 4,
                      label: "Credit Limit",
                      value: data.data.balance * -1,
                    },
                  ],
                  creditLimit: data.data.balance,
                });
              }
            }
          }
        });
      } else {
        showLoador({ loador: true });
        apiGet({
          url: endpoint.stackholder + "/get-credit-limit-by-user",
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({
              msg: creditLimitMsg,
              severity: "error",
            });
          } else {
            if (Object.keys(data.data).length !== 0) {
              if (data.error) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                this.setState({
                  DataToSet: [
                    {
                      xs: 12,
                      sm: 4,
                      md: 4,
                      lg: 4,
                      label: "Credit Limit",
                      value:
                        data.data.creditLimit !== null
                          ? data.data.creditLimit
                          : 0,
                    },
                  ],
                  creditLimit:
                    data.data.creditLimit !== null ? data.data.creditLimit : 0,
                });
              }
            }
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }

    await this.getData();
  }
  getData = async () => {
    const { getTodaysPlaceOrder, showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getTodaysPlaceOrder().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  onSearchList = (data) => {
    const {
      getPlaceOrderSearchListHeaderDetails,
      showLoador,
      showNotification,
    } = this.props;

    this.setState({
      fromdate: data.fromdate,
      todate: data.todate,
    });
    if (navigator.onLine) {
      showLoador({ loador: true });
      getPlaceOrderSearchListHeaderDetails({
        fromdate: data.fromdate,
        todate: data.todate,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowPDF = (rowData) => {
    const { lang, fromdate, todate } = this.state;

    let isShowPurchaseOrderPdfProductWise = localStorage.getItem("isShowPurchaseOrderPdfProductWise");

    let date = {
      fromdate: fromdate ? fromdate : moment(new Date()).format("DD-MM-YYYY"),
      todate: todate ? todate : moment(new Date()).format("DD-MM-YYYY"),
    };
    localStorage.setItem("dateForPDF", JSON.stringify(date));
    localStorage.setItem("lang", lang);
    localStorage.setItem("loadSheetStockHolderOrderID", rowData.id);
    if (isShowPurchaseOrderPdfProductWise == 1) {
      window.open("./purchase-order-product-wise-pdf", "_blank");
    } else {
      window.open("./purchase-order-pdf", "_blank");
    }
  };

  onChangeStatusStatic = (row) => {
    const { getTodaysPlaceOrder, showLoador, showNotification } = this.props;
    const {
      fromdate,
      showOrderConfiguration,
      todate,
      comment,
      creditLimit,
    } = this.state;

    const isShowSapCreditLimitAtPlaceOrder =
      localStorage.getItem("isShowSapCreditLimitAtPlaceOrder") !== null ?
        localStorage.getItem("isShowSapCreditLimitAtPlaceOrder") : 0;

    let newCreditLimit = creditLimit * -1;

    let isCreditLimitApplicable = localStorage.getItem(
      "isCreditLimitApplicable"
    );

    if (isCreditLimitApplicable == 1) {
      if (
        isShowSapCreditLimitAtPlaceOrder == 1
          ? +row.totalAmt > newCreditLimit
          : +row.totalAmt > creditLimit
      ) {
        showNotification({
          msg: sendPlacedOrderMsg,
          severity: "error",
        });
      } else {
        if (row.id) {
          swal({
            text: sendOrder,
            icon: "warning",
            buttons: true,
            dangerMode: true,
          }).then(async (willDelete) => {
            if (willDelete) {
              if (navigator.onLine) {
                if (showOrderConfiguration == 1) {
                  showLoador({ loador: true });
                  apiGet({
                    url:
                      endpoint.stockHolderOrderingConfiguration +
                      "/is-show-send-button",
                  }).then(({ data, success }) => {
                    if (success) {
                      showLoador({ loador: false });
                      if (data.data.statusCode == 500) {
                        showLoador({ loador: false });
                        showNotification({
                          msg: "Order sending duration has already exceeded, Due to which unable to send order to the superior",
                          severity: "error",
                        });
                      } else {
                        showLoador({ loador: true });
                        apiGet({
                          url:
                            endpoint.stockStakeholderOrderHeader +
                            "/update-status?ids=" +
                            row.id +
                            "&status=1&remark=" +
                            row.remark,
                        }).then(({ success }) => {
                          if (success) {
                            showLoador({ loador: false });
                            showNotification({
                              msg: statusmsg,
                            });
                            this.getData();
                          } else {
                            showNotification({
                              msg: serverMsg,
                              severity: "error",
                            });
                            showLoador({ loador: false });
                          }
                        });
                      }
                    } else {
                      showNotification({
                        msg: serverMsg,
                        severity: "error",
                      });
                      showLoador({ loador: false });
                    }
                  });
                } else {
                  showLoador({ loador: true });
                  apiGet({
                    url:
                      endpoint.stockStakeholderOrderHeader +
                      "/update-status?ids=" +
                      row.id +
                      "&status=1&remark=" +
                      row.remark,
                  }).then(({ success }) => {
                    if (success) {
                      showLoador({ loador: false });
                      showNotification({
                        msg: statusmsg,
                      });
                      this.getData();
                    } else {
                      showNotification({
                        msg: serverMsg,
                        severity: "error",
                      });
                      showLoador({ loador: false });
                    }
                  });
                }
              } else {
                showNotification({ msg: noInternetMsg, severity: "error" });
              }
            }
          });
        }
      }
    } else {
      if (row.id) {
        swal({
          text: sendOrder,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then(async (willDelete) => {
          if (willDelete) {
            if (navigator.onLine) {
              if (showOrderConfiguration == 1) {
                showLoador({ loador: true });
                apiGet({
                  url:
                    endpoint.stockHolderOrderingConfiguration +
                    "/is-show-send-button",
                }).then(({ data, success }) => {
                  if (success) {
                    showLoador({ loador: false });
                    if (data.data.statusCode == 500) {
                      showLoador({ loador: false });
                      showNotification({
                        msg: "Order sending duration has already exceeded, Due to which unable to send order to the superior",
                        severity: "error",
                      });
                    } else {
                      showLoador({ loador: true });
                      apiGet({
                        url:
                          endpoint.stockStakeholderOrderHeader +
                          "/update-status?ids=" +
                          row.id +
                          "&status=1&remark=" +
                          row.remark,
                      }).then(({ success }) => {
                        if (success) {
                          showLoador({ loador: false });
                          showNotification({
                            msg: statusmsg,
                          });
                          this.getData();
                        } else {
                          showNotification({
                            msg: serverMsg,
                            severity: "error",
                          });
                          showLoador({ loador: false });
                        }
                      });
                    }
                  } else {
                    showNotification({
                      msg: serverMsg,
                      severity: "error",
                    });
                    showLoador({ loador: false });
                  }
                });
              } else {
                showLoador({ loador: true });
                apiGet({
                  url:
                    endpoint.stockStakeholderOrderHeader +
                    "/update-status?ids=" +
                    row.id +
                    "&status=1&remark=" +
                    row.remark,
                }).then(({ success }) => {
                  if (success) {
                    showLoador({ loador: false });
                    showNotification({
                      msg: statusmsg,
                    });
                    this.getData();
                  } else {
                    showNotification({
                      msg: serverMsg,
                      severity: "error",
                    });
                    showLoador({ loador: false });
                  }
                });
              }
            } else {
              showNotification({ msg: noInternetMsg, severity: "error" });
            }
          }
        });
      }
    }
  };

  render() {
    const { orderList } = this.props;
    const { comment, popUpFlag, DataToSet } = this.state;

    return (
      <>
        <DynamicMainScreen
          deleteMsgAuto={true}
          showViewButtonInTable={true}
          showDeleteIcon={false}
          searchList={PlaceOrderTableJson.searchList}
          onSearchData={this.onSearchList}
          formPathView={PlaceOrderTableJson.formPathView}
          formPath={PlaceOrderTableJson.formPath}
          screenTitle={PlaceOrderTableJson.screenTitle}
          fieldMeta={PlaceOrderTableJson.fieldMeta}
          showPdfDownload={false}
          showExcelDownload={false}
          isActiveURL={PlaceOrderTableJson.isActiveURL}
          showAddButton={PlaceOrderTableJson.showAddButton}
          tableColumns={PlaceOrderColumns}
          tableData={orderList.placeOrderByDate}
          apiBaseURL={PlaceOrderTableJson.apiBaseURL}
          callApi={false}
          getTableDataById={true}
          showSearchBox={true}
          rowPDF={this.rowPDF}
          showPdf={true}
          showPegination={false}
          onChangeStatusStatic={this.onChangeStatusStatic}
          editConditionName="status"
          editConditionValue="0"
          chipCompoColor={true}
          getTableData={this.getData}
          DataToSet={DataToSet}
          tableColumnsToFilter={PlaceOrderTableJson.tableColumnsToFilter}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  orderList: state.orderHeaderList,
});

const mapDispatchToProps = {
  showNotification,
  showLoador,
  getPlaceOrderSearchListHeaderDetails,
  getTodaysPlaceOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaceOrderTable);
